export const QUANTITY_RANGES = [
    { key: 'any_quantity', label: 'Any Quantity' },
    { key: 'gte_500', label: 'More than 500 items' },
    { key: 'gte_1000', label: 'More than 1,000 items' },
    { key: 'gte_5000', label: 'More than 5,000 items' },
    { key: 'gte_10000', label: 'More than 10,000 items' },
];
export const QUANTITY_RANGES_MIN = [
    { key: 'any_quantity', label: 'Any Quantity' },
    { key: 'gte_500', label: '≥ 500' },
    { key: 'gte_1000', label: '≥ 1,000' },
    { key: 'gte_5000', label: '≥ 5,000' },
    { key: 'gte_10000', label: '≥ 10,000' },
];
